import React, { useState, useEffect } from "react";
//images and icons
import INSTA from "../../../assets/images/icons/newInsta.svg";
import WHATSAPP from "../../../assets/images/icons/whatsapp.svg";
import EMAIL from "../../../assets/images/icons/customer-care.svg";
import TWITTER from "../../../assets/images/icons/twitter-x-red.svg";
import FACEBOOK from "../../../assets/images/icons/newFacebook.svg";
import Banner from "../../../assets/images/pictures/help-banner.jpg";
import BannerDark from "../../../assets/images/pictures/help-banner-dark.png";

export default function ContactUs() {
  const [isDarkMode, setIsDarkMode] = useState(false);

  useEffect(() => {
    if (document.documentElement.classList.contains("dark")) {
      setIsDarkMode(true);
    }
  }, []);

  return (
    <div data-test="contact-us-page">
      <div
        className="h-96 bg-cover no-repeat bg-center relative z-0"
        style={{
          backgroundImage: `url('${isDarkMode ? BannerDark : Banner}')`,
        }}
      ></div>

      <div className="py-16 max-w-6xl px-6 mx-auto bg-white dark:bg-[#010101] relative -top-96 sm:-top-72">
        <p className="text-2xl text-primary sm:mt-2 mb-6 capitalize font-bold">
          Contact Us
        </p>
        <p className="text-[20px] dark:text-[#BCBCBC] my-3">
          At Ogwugo, we deliver your favorite meals, groceries, and essentials
          from top local restaurants and stores in Enugu and beyond—fast and
          reliably.
        </p>
        <p className="text-[20px] dark:text-[#BCBCBC] my-3">
          Whether you need help with an order, the app, deliveries, or
          partnering as a vendor, our friendly support team is always ready to
          assist, ensuring a smooth and satisfying experience.
        </p>

        <main className="py-8">
          <div className="max-w-6xl mx-auto lg:max-w-7xl">
            <div
              className="sm:mt-8 justify-center items-center mx-auto"
              data-test="contactPage"
            >
              <div className="max-w-3xl">
                <a
                  href="tel:+2348140019523"
                  className="text-base text-start text-[#2b3674]"
                >
                  <div className="flex items-center py-3 bg-white dark:bg-[#121212] px-5 sm:px-10 cursor-pointer shadow-lg rounded-lg h-[91px] sm:py-4 mb-6">
                    <div className="flex">
                      <img src={EMAIL} alt="email" />
                      <div className="ml-5">
                        <span className="dark:text-[#9CA3AF]">
                          Customer Service
                        </span>
                      </div>
                    </div>
                  </div>
                </a>
                <a
                  href=" https://wa.me/message/FSYIRWHUMOYEJ1"
                  target={"_blank"}
                  className="text-base text-start text-[#2b3674]"
                >
                  <div className="flex items-center py-3 bg-white dark:bg-[#121212] px-5 sm:px-10 shadow-lg rounded-lg h-[91px] sm:py-4 mb-6">
                    <div className="flex items-center justify-between ">
                      <div className="flex">
                        <img src={WHATSAPP} alt="Whatsapp" />
                        <div className="ml-5 ">
                          <span className="dark:text-[#9CA3AF]">Whatsapp</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </a>

                <a
                  href="https://web.facebook.com/ogwugofood/?_rdc=1&_rdr"
                  target="_blank"
                  rel="noopener noreferrer"
                  title="facebook"
                  className="text-base text-start text-[#2b3674]"
                >
                  <div className="flex items-center py-3 bg-white dark:bg-[#121212] px-5 sm:px-10 shadow-lg rounded-lg h-[91px] sm:py-4 mb-6">
                    <div className="flex">
                      <img src={FACEBOOK} alt="phone" />
                      <div className="ml-5 ">
                        <span className="dark:text-[#9CA3AF]">Facebook</span>
                      </div>
                    </div>
                  </div>
                </a>

                <a
                  href="https://twitter.com/ogwugofood?lang=en"
                  target={"_blank"}
                  className="text-base text-start text-[#2b3674]"
                  title="twitter"
                  rel="noopener noreferrer"
                >
                  <div className="flex items-center py-3 bg-white dark:bg-[#121212] px-5 sm:px-10 shadow-lg rounded-lg h-[91px] sm:py-4 mb-6">
                    <div className="flex">
                      <img src={TWITTER} alt="phone" />
                      <div className="ml-5 ">
                        <span className="dark:text-[#9CA3AF]">Twitter</span>
                      </div>
                    </div>
                  </div>
                </a>

                <a
                  href="https://www.instagram.com/ogwugofood/?hl=en"
                  target="_blank"
                  title="instagram"
                  rel="noopener noreferrer"
                  className="text-base text-start text-[#2b3674]"
                >
                  <div className="flex items-center py-3 bg-white dark:bg-[#121212] px-5 sm:px-10 shadow-lg rounded-lg h-[91px] sm:py-4 mb-6">
                    <div className="flex">
                      <img src={INSTA} alt="Instagram" />
                      <div className="ml-5 text-left ">
                        <span className="dark:text-[#9CA3AF]">Instagram</span>
                      </div>
                    </div>
                  </div>
                </a>
              </div>
            </div>
          </div>
        </main>
      </div>
    </div>
  );
}
